<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block text-center">
    <mat-card-content>
        <img src="images/access-denied.svg" alt="error-image">
        <h3>
            403 Access Denied!
        </h3>
        <p>
            You are not authorized to access this page.
        </p>
        <a [routerLink]="['/']" routerLinkActive="router-link-active">Go to Home</a>
    </mat-card-content>
</mat-card>
